import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SellCarSEO = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const seoData = labels.menuPages?.sellCar?.seo || {};

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: seoData.title || "BILENIA Bilförsäljning Online",
    description:
      seoData.description ||
      "Professionell bilförsäljning online via BILENIA och BEA Auktioner med automatisk värdering och personlig service.",
    provider: {
      "@type": "AutoDealer",
      name: "BILENIA",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Hägerstens Allé 10",
        addressLocality: "Hägersten",
        postalCode: "129 37",
        addressCountry: "SE",
      },
    },
    areaServed: ["Sverige", "Norden", "Europa"],
    serviceType: "Bilförsäljning",
    offers: {
      "@type": "Offer",
      description:
        seoData.description || "Sälja bil online med automatisk värdering",
      availability: "https://schema.org/InStock",
    },
  };

  return (
    <>
      <title>
        {seoData.title ||
          "Sälja Bil Online | BILENIA & BEA Auktioner - Sverige, Norden & Europa"}
      </title>
      <meta
        name="description"
        content={
          seoData.description ||
          "Sälja din bil enkelt online via BILENIA och BEA Auktioner."
        }
      />
      <meta
        name="keywords"
        content={
          seoData.keywords ||
          "sälja bil online, bilauktion, BEA auktioner, sälja bil sverige"
        }
      />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </>
  );
};

export default SellCarSEO;
